import { combineReducers } from 'redux';
import { AuthReducer, MessageReducer, SIGNUPReducer } from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { PROJECTAddReducer, PROJECTDeleteReducer, PROJECTReducer, PROJECTUpdateReducer } from './project-links/reducers';
import { DAILY_WORKAddReducer, EMPLOYEE_DATAReducer, EMPLOYEEReducer, HOLIDAYAddReducer, HOLIDAYDeleteReducer, holidayUpdateReducer, PERSONAddReducer, PERSONReducer, PERSONUpdateReducer, PERSONWORKReducer, SINGLEPERSONReducer } from './person/reducers';
import { ASSIGNEDTasksReducer, ASSIGNTaskToPersonReducer, GETTasksByUserReducer, SINGLETaskReducer, TASKAddReducer, TASKINFOReducer, TASKReducer, TASKUpdateReducer } from './tasks/reducers';
import { ADMINUpdateReducer, CHANGEPASSWORDReducer, RESETPASSWORDReducer } from './userProfile/reducers';
import { GETProgressByTaskReducer, PROGRESSAddReducer, PROGRESSCommentAddReducer, TODAYProgressReducer } from './progress/reducers';
import { TODOAddReducer, TODODeleteReducer, TODOReducer, TODOUpdateReducer } from './todo/reducers';
import { NOTIFICATIONSDeleteReducer, NOTIFICATIONSReducer } from './Notifications/reducers';
import { DESIGNATIONSAddReducer, DESIGNATIONSReducer, DESIGNATIONSUpdateReducer } from './designation/reducers';
import { GETLEAVESDATAReducer, GETLEAVESReducer, GETLEAVESREQUESTReducer, GETMAILReducer, LEAVEUPDATEUpdateReducer, MAILAddReducer, MAILReducer } from './mail/reducers';
import { REQUIREMENTADDReducer, REQUIREMENTReducer, REQUIREMENTUPDATEReducer } from './requirements/reducers';
import { PRODUCTAddReducer, PRODUCTDeleteReducer, PRODUCTReducer, PRODUCTUpdateReducer } from './Product/reducers';
import { GetTeamGroupReducer, TEAMGROUPAddReducer, TEAMGROUPDeleteReducer, teamgroupUpdateReducer } from './teamgroup/reducers';

const rootReducers = combineReducers({
  auth: AuthReducer,
  ChangeLayoutMode,
  msg: MessageReducer,
  getTeamData: GetTeamGroupReducer,
  deleteTeamdata: TEAMGROUPDeleteReducer,
  upateTeamData: teamgroupUpdateReducer,
  teamGroupData: TEAMGROUPAddReducer,
  LeaveRequestRes: GETLEAVESREQUESTReducer,
  LeaveUpdateRes: LEAVEUPDATEUpdateReducer,
  HolidayUpdateRes: holidayUpdateReducer,
  HolidayAddRes: HOLIDAYAddReducer,
  HolidayDeleteRes: HOLIDAYDeleteReducer,
  TaskInfoRead: TASKINFOReducer,
  GetLeaveData: GETLEAVESDATAReducer,
  ProductAddRes: PRODUCTAddReducer,
  ProductUpdateRes: PRODUCTUpdateReducer,
  ProductGet: PRODUCTReducer,
  ProductDeleteRes: PRODUCTDeleteReducer,
  ProjectRes: PROJECTReducer,
  ProjectAddRes: PROJECTAddReducer,
  ProjectUpdateRes: PROJECTUpdateReducer,
  ProjectDeleteRes: PROJECTDeleteReducer,
  PersonRes: PERSONReducer,
  PersonAddRes: PERSONAddReducer,
  Dailywork: DAILY_WORKAddReducer,
  PersonWork: PERSONWORKReducer,
  EmployeeData: EMPLOYEE_DATAReducer,
  Employeedata: EMPLOYEEReducer,
  Getemaildata: GETMAILReducer,
  GetEmployeeLeavesData: GETLEAVESReducer,
  PersonUpdateRes: PERSONUpdateReducer,
  TaskRes: TASKReducer,
  TaskAddRes: TASKAddReducer,
  TaskUpdateRes: TASKUpdateReducer,
  AssignedTasksRes: ASSIGNEDTasksReducer,
  SingleTaskRes: SINGLETaskReducer,
  AssignTaskToPersonRes: ASSIGNTaskToPersonReducer,
  SignUpRes: SIGNUPReducer,
  ChangePasswordRes: CHANGEPASSWORDReducer,
  GetTasksByUserRes: GETTasksByUserReducer,
  ProgressAddRes: PROGRESSAddReducer,
  ProgressCommentAddRes: PROGRESSCommentAddReducer,
  GetProgressByTaskRes: GETProgressByTaskReducer,
  SinglePersonRes: SINGLEPERSONReducer,
  TodoRes: TODOReducer,
  TodoAddRes: TODOAddReducer,
  TodoUpdateRes: TODOUpdateReducer,
  TodoDeleteRes: TODODeleteReducer,
  ResetPasswordRes: RESETPASSWORDReducer,
  AdminUpdateRes: ADMINUpdateReducer,
  NotificationsRes: NOTIFICATIONSReducer,
  NotificationsDeleteRes: NOTIFICATIONSDeleteReducer,
  DesignationsRes: DESIGNATIONSReducer,
  DesignationsAddRes: DESIGNATIONSAddReducer,
  DesignationsUpdateRes: DESIGNATIONSUpdateReducer,
  TodayProgressRes: TODAYProgressReducer,
  MailRes: MAILReducer,
  MailAddRes: MAILAddReducer,
  RequirementAddRes: REQUIREMENTADDReducer,
  RequirementRes: REQUIREMENTReducer,
  RequirementUpdateRes: REQUIREMENTUPDATEReducer,
});

export default rootReducers;
